export default "__VITE_ASSET__FvXz9WVS__"